import { useEffect, useState } from 'react';

/**
 * Return whether or not the window is currently scrolled
 */
const useWindowIsScrolled = () => {
    const [isScrolled, setIsScrolled] = useState(!!window.scrollY);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(!!window.scrollY);
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, []);

    return isScrolled;
};

export default useWindowIsScrolled;
